import { FormEvent, useState } from 'react';
import { Navigate, useNavigate, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { authApi } from '../../api';
import { getErrorMessage } from '../../api/client';
import { useAuthStore } from '../../store/auth';

export function RegisterPage() {
  const user = useAuthStore((s) => s.user);
  const setAuth = useAuthStore((s) => s.setAuth);
  const navigate = useNavigate();

  const [fullName, setFullName] = useState('');
  const [businessName, setBusinessName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (user) return <Navigate to="/dashboard" replace />;

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    setLoading(true);
    try {
      await authApi.register({ fullName, businessName, email, password });
      // Auto-login into the new trialing workspace.
      const res = await authApi.login(email, password);
      setAuth(res.user, res.accessToken, res.refreshToken);
      toast.success('Welcome to your OmniRetail trial!');
      navigate('/dashboard');
    } catch (err) {
      setError(getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg,#0f1f1c 0%,#0b1512 100%)', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 440, background: '#fff', borderRadius: 20,
        boxShadow: '0 24px 60px rgba(0,0,0,0.25)', padding: 32 }}>
        <div style={{ marginBottom: 8, fontSize: 12, fontWeight: 700, letterSpacing: 1,
          textTransform: 'uppercase', color: '#0d9488' }}>OmniRetail</div>
        <h1 style={{ fontSize: 26, fontWeight: 800, margin: '0 0 6px', color: '#0f172a' }}>Start your free trial</h1>
        <p style={{ margin: '0 0 24px', color: '#64748b', fontSize: 14 }}>
          Create your own workspace — full access during the trial, subscribe anytime.
        </p>

        {error && (
          <div style={{ background: '#fef2f2', color: '#b91c1c', borderRadius: 10, padding: '10px 12px',
            fontSize: 13, marginBottom: 16 }}>{error}</div>
        )}

        <form onSubmit={submit}>
          <Field label="Your name">
            <input value={fullName} onChange={(e) => setFullName(e.target.value)} required
              placeholder="Jane Doe" style={inputStyle} />
          </Field>
          <Field label="Business name">
            <input value={businessName} onChange={(e) => setBusinessName(e.target.value)} required
              placeholder="Acme Retail" style={inputStyle} />
          </Field>
          <Field label="Email address">
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              placeholder="you@business.com" style={inputStyle} />
          </Field>
          <Field label="Password">
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              placeholder="At least 8 characters" style={inputStyle} />
          </Field>
          <button type="submit" disabled={loading}
            style={{ width: '100%', marginTop: 8, padding: '12px 16px', borderRadius: 12, border: 'none',
              background: '#0d9488', color: '#fff', fontWeight: 700, fontSize: 15,
              cursor: loading ? 'default' : 'pointer', opacity: loading ? 0.7 : 1 }}>
            {loading ? 'Creating your workspace…' : 'Create account & start trial'}
          </button>
        </form>

        <div style={{ marginTop: 20, textAlign: 'center', fontSize: 13, color: '#64748b' }}>
          Already have an account?{' '}
          <Link to="/login" style={{ color: '#0d9488', fontWeight: 600, textDecoration: 'none' }}>Sign in</Link>
        </div>
      </div>
    </div>
  );
}

const inputStyle: React.CSSProperties = {
  width: '100%', padding: '11px 13px', borderRadius: 10, border: '1px solid #e2e8f0',
  fontSize: 14, outline: 'none', boxSizing: 'border-box',
};

function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={{ display: 'block', marginBottom: 6, fontSize: 13, fontWeight: 600, color: '#334155' }}>{label}</label>
      {children}
    </div>
  );
}
